import PropTypes from "prop-types";
import React from "react";
import { ArrowDown, ArrowUp, ArrowHover } from "../../../assets/icons";
import { getBookedVacationTooltipForRE } from "../dashboard-util/dashboard-utils";

const TableHeaderColumn = ({
  headerText,
  sortKey,
  colClass = "",
  requestSort,
  getArrowDirectionFor,
  getBookedVacation = false,
}) => {
  const content = (
      <th className={`${colClass} headerSorted`}>
        <div onClick={() => requestSort(sortKey)} className={'sortedLeft'} >
          <div className="containerTextSortedLeft">
            <p className="textSorted">{headerText}</p>
          </div>
          {getArrowDirectionFor(sortKey, "descending") && (
            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
          )}
          {getArrowDirectionFor(sortKey, "ascending") && (
            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
          )}
          {getArrowDirectionFor(sortKey) && (
            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
          )}
        </div>
      </th>
  );

  return getBookedVacation ? getBookedVacationTooltipForRE(content) : content;
};

TableHeaderColumn.propTypes = {
  headerText: PropTypes.string.isRequired,
  sortKey: PropTypes.string.isRequired,
  colClass: PropTypes.string,
  requestSort: PropTypes.func.isRequired,
  getArrowDirectionFor: PropTypes.func.isRequired,
  getBookedVacation: PropTypes.bool,
};

export default TableHeaderColumn;
